import axios from 'axios'
import NProgress from 'nprogress'

import { store } from '../store/store'
import router from '../router'
import eventBus from '@/event_bus'

axios.defaults.baseURL = process.env.BASE_URL

axios.interceptors.request.use((config) => {
  if (config.url[0] === '/' && store.getters.getPathIdList.length > 0 && store.getters.getNowPathId) {
    config.headers['Url-Key'] = store.getters.getNowPathId
  }
  if (config.url.includes('auth/refresh')) {
    config.headers.Authorization = `Bearer ${localStorage.getItem('refreshToken')}`
  } else if (!config.url.includes('logout')) {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
  }
  if (config.NProgress !== false) {
    NProgress.start()
  }
  return config
})

axios.interceptors.response.use(
  (config) => {
    if (config.NProgress !== false) {
      NProgress.done()
    }
    return config
  },
  (error) => {
    NProgress.done()
    if (error.response) {
      const isValidToken = localStorage.getItem('isAuthorized') === 'true'
      const data = error.response.data
      if (!data.message && !data.code) {
        eventBus.$emit('DialogPopup', {
          useDialog: true,
          messageHTML: `<dl class="txt"><dd>code : ${error.response.status}<br />statusText : ${error.response.statusText}</dd></dl>`
        })
      }
      if (
        data.message &&
        (data.code === -2021 ||
          data.code === -1 ||
          data.code === -4 ||
          data.code === -8 ||
          data.code === -9 ||
          data.code === -10 ||
          data.code === -11)
      ) {
        eventBus.$emit('DialogPopup', {
          useDialog: true,
          messageHTML: `<dl class="txt"><dd>${error.response.data.message}</dd></dl>`
        })
      }
      if (data.message && data.code === -502) {
        eventBus.$emit('DialogPopup', {
          useDialog: true,
          messageHTML: `<dl class="txt"><dd>ネットワークの状態がよくないため<br />ユーザー要請を完了できませんでした。<br />しばらくしてからもう一度お試しください。</dd></dl>`
        })
      }
      if (data.message && data.code !== -5 && isValidToken) {
        localStorage.setItem('isAuthorized', 'false')
        setTimeout(() => {
          eventBus.$emit('DialogPopup', {
            useDialog: true,
            messageHTML: `<dl class="txt"><dd>${error.response.data.message}</dd></dl>`
          })
        }, 100)
      }
      if (error.response && error.response.status === 401 && localStorage.getItem('token')) {
        if (error.response.data.code === -6) {
          store.dispatch('forceLogout').then((res) => {
            if (res && router.app.$route.path !== '/member/login') {
              router.push(store.state.isAdministratorRole ? '/member/adminlogin' : '/member/login')
            }
          })
        } else {
          if (error.response.data.code !== -1 && error.response.data.code !== -5) {
            store.dispatch('logout').then((res) => {
              if (res && router.app.$route.path !== '/member/login') {
                router.push(store.state.isAdministratorRole ? '/member/adminlogin' : '/member/login')
              }
            })
          }
        }
      }
    } else {
      if (error.toString().indexOf('Network Error') > -1) {
        eventBus.$emit('DialogPopup', {
          useDialog: true,
          messageHTML: `<dl class="txt"><dd>ネットワークの状態がよくないため<br />ユーザー要請を完了できませんでした。<br />しばらくしてからもう一度お試しください。</dd></dl>`
        })
      }
    }
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/http/index.js